import {
  LOBBY_GET_LANGUAGES_FAILURE,
  LOBBY_GET_LANGUAGES_SUCCESS,
  LOBBY_GET_PARAMS_FAILURE,
  LOBBY_GET_PARAMS_SUCCESS,
  TOGGLE_CONTACTS_MODAL,
  TOGGLE_INFO_MODAL,
  TOGGLE_RULES_MODAL,
  TOGGLE_SPORT_BETS_HISTORY_MODAL,
} from "@shared/constants";

import { createReducer } from "./utils";

/**
 * Represents the initial state object for the application, containing the slider configuration.
 *
 * @typedef {Object} InitialState
 * @property {slider | null} slider - The slider configuration object with an array of banners.
 */

/**
 * Represents a slider configuration with banners.
 *
 * @typedef {Object} slider
 * @property {Banner[]} banners - An array of banner objects representing individual banners.
 */

/**
 * Represents a banner in the slider.
 *
 * @typedef {Object} Banner
 * @property {number} id - The unique identifier for the banner.
 * @property {string} type - The type of the banner.
 * @property {null|string} bonusId - The bonus identifier or null if not applicable.
 * @property {BackgroundImages} backgroundImage - The background images for the banner.
 * @property {BannerText[]} titles - The titles for the banner in multiple languages.
 * @property {BannerText[]} subtitles - The subtitles for the banner in multiple languages.
 * @property {null} action - The action associated with the banner or null if not specified.
 */

/**
 * Represents the background images for a banner.
 *
 * @typedef {Object} BackgroundImages
 * @property {string} desktop - The desktop background image URL.
 * @property {string} mobile - The mobile background image URL.
 */

/**
 * Represents banner text in different languages.
 *
 * @typedef {Object} BannerText
 * @property {string} lang - The language code for the text.
 * @property {string} value - The text content in the specified language.
 */
const initialState = {
  languages: null,
  params: null,
  showContactsModal: false,
  showInfoModal: false,
  showSportBetsHistoryModal: false,
  rulesModal: {
    type: "TermsAndConditions",
    isShow: false,
  },
  slider: null,
};

export default createReducer(initialState, {
  [LOBBY_GET_PARAMS_SUCCESS](state, action) {
    return {
      ...state,
      params: action.payload,
    };
  },
  [LOBBY_GET_LANGUAGES_SUCCESS](state, action) {
    return {
      ...state,
      languages: action.payload,
    };
  },
  [TOGGLE_CONTACTS_MODAL](state, action) {
    return {
      ...state,
      showContactsModal: action.payload,
    };
  },

  [LOBBY_GET_PARAMS_FAILURE](state) {
    return { ...state };
  },

  [LOBBY_GET_LANGUAGES_FAILURE](state) {
    return {
      ...state,
      languages: null,
    };
  },

  [TOGGLE_INFO_MODAL](state, action) {
    return {
      ...state,
      showInfoModal: action.payload,
    };
  },
  [TOGGLE_RULES_MODAL](state, action) {
    return {
      ...state,
      rulesModal: {
        isShow: action.payload.isShow,
        type: action.payload.type,
      },
    };
  },
  [TOGGLE_SPORT_BETS_HISTORY_MODAL](state, action) {
    return {
      ...state,
      showSportBetsHistoryModal: action.payload,
    };
  },
});
